/**
 * Online booking (WP3-BOOKING, BUILD-PLAN M14): the Online Requests queue,
 * availability board with the "Why not bookable?" explainer, setup and
 * funnel. The public patient app is `apps/booking-web`.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'booking',
    title: 'Online booking',
    version: '0.1.0',
    owner: 'WP3-BOOKING',
    entitlementKey: 'online_booking',
    permissions: ['schedule.view', 'schedule.edit'],
    routes: [
      {
        id: 'queue',
        path: '/booking',
        title: 'Online booking',
        officeScope: 'location-or-all',
        permission: 'schedule.view',
        readsPhi: true,
      },
    ],
    nav: [
      { label: 'Online booking', group: 'schedule', routeId: 'queue', icon: 'calendar', order: 20 },
    ],
    commands: [
      {
        id: 'booking.open',
        title: 'Open online booking requests',
        keywords: ['online', 'requests', 'web booking', 'approve', 'book online', 'leads'],
        routeId: 'queue',
      },
    ],
    sseEntityKeys: ['booking_request'],
  }),
  pages: {
    queue: () => import('./BookingPage.js'),
  },
});
